module.exports = __webpack_public_path__ + "img/theme1.f9d7219b.png";